import React from "react";
import Setup from "../constants/main";
import { isMobile, getComputedTranslateXY } from "../constants/config";
import { TweenLite } from "gsap/all";

let map = null;
let isDown = false;
let mousePosition = {};
let offset = [0, 0];

function InteractiveMap({ fullScreen, infoOpen, classes, infoClose }) {
  const mapEl = React.useRef(null);
  InteractiveMap.fullScreen = fullScreen;
  InteractiveMap.infoOpen = infoOpen;

  React.useEffect(() => {
    let mapContainer = document.getElementById("map_container");
    //ComponentDidMount
    // fetchData(mapEl);
    if (!isMobile()) {
      document
        .getElementById("map_container")
        .addEventListener("mousewheel", handMouseWheel, {
          passive: true
        });
      document.addEventListener("click", InteractiveMap.handleIsUp);
      mapContainer.addEventListener(
        "mousedown",
        InteractiveMap.handleIsDown,
        true
      );
      mapContainer.addEventListener("mouseup", InteractiveMap.handleIsUp, true);
      mapContainer.addEventListener("mousemove", handleMove);
    } else {
      mapContainer.addEventListener(
        "touchstart",
        InteractiveMap.handleTIsDown,
        true
      );
      mapContainer.addEventListener(
        "touchend",
        InteractiveMap.handleIsUp,
        true
      );

      mapContainer.addEventListener("touchmove", handleTMove);
    }

    map = new Setup(mapEl, InteractiveMap);
  }, []);

  React.useEffect(() => {
    let mapContainer = document.getElementById("map_container");
    return () => {
      if (!fullScreen) {
        if (!isMobile()) {
          document
            .getElementById("map_container")
            .removeEventListener("wheel", handMouseWheel, {
              passive: true
            });
        }
        isDown = false;
        document.removeEventListener("click", InteractiveMap.handleIsUp);

        mapContainer.removeEventListener(
          "mousedown",
          InteractiveMap.handleIsDown,
          true
        );
        mapContainer.removeEventListener(
          "mouseup",
          InteractiveMap.handleIsUp,
          true
        );
        mapContainer.removeEventListener("mousemove", handleMove, true);
      } else {
        document.addEventListener("click", InteractiveMap.handleIsUp);
        if (!isMobile()) {
          mapContainer.addEventListener(
            "mousedown",
            InteractiveMap.handleIsDown,
            true
          );
          mapContainer.addEventListener(
            "mouseup",
            InteractiveMap.handleIsUp,
            true
          );

          mapContainer.addEventListener("mousemove", handleMove);
        }
        if (!isMobile()) {
          document
            .getElementById("map_container")
            .addEventListener("wheel", handMouseWheel, {
              passive: true
            });
        }
      }

      InteractiveMap.toggle();
    };
  }, [fullScreen]);

  return (
    <div
      id="map_container"
      style={{
        width: fullScreen ? "100%" : null,
        paddingLeft: fullScreen ? 0 : null,
        background: fullScreen ? "none" : null
      }}
      className={classes}
    >
      <svg
        id="background_container"
        width="100%"
        height="100%"
        className="sprite"
      />
      <svg id="map" width="100%" height="100%" ref={mapEl} />
      <div id="CLOUDS2" style={{ width: fullScreen ? "100vw" : null }} />
    </div>
  );
}

InteractiveMap.handleIsUp = (e = null) => {
  isDown = false;
};

InteractiveMap.handleIsDown = (e = null) => {
  const mapContainer = document.getElementById("map_container");
  isDown = true;

  offset = [getComputedTranslateXY(mapContainer)[0] - e.clientX, 0];
};

InteractiveMap.handleTIsDown = (e = null) => {
  const mapContainer = document.getElementById("map_container");
  isDown = true;

  offset = [getComputedTranslateXY(mapContainer)[0] - e.touches[0].clientX, 0];
};

const handMouseWheel = event => {
  const { deltaY } = event;
  event.preventDefault();
  const mapContainer = document.getElementById("map_container");
  const position = getComputedTranslateXY(mapContainer)[0];
  const endMax = -(mapContainer.offsetWidth - window.innerWidth);

  if (deltaY > 0) {
    if (position - 20 > endMax) {
      TweenLite.set("#map_container", { x: "-=20" });
    }
  } else {
    if (position + 20 < 0) {
      TweenLite.set("#map_container", { x: "+=20" });
    }
  }
};

function handleMove(event) {
  let mapContainer = document.getElementById("map_container");
  event.preventDefault();
  if (isDown) {
    mousePosition = {
      x: event.clientX,
      y: event.clientY
    };
    const position = offset[0] + mousePosition.x;
    const endMax = -(mapContainer.offsetWidth - window.innerWidth);
    if (position < 0 && position >= endMax) {
      TweenLite.set(mapContainer, { x: position });
    }
  }
}

function handleTMove(event) {
  let mapContainer = document.getElementById("map_container");
  event.preventDefault();
  if (isDown) {
    mousePosition = {
      x: event.touches[0].clientX
    };
    const position = offset[0] + mousePosition.x;
    const endMax = -(mapContainer.offsetWidth - window.innerWidth);
    if (position < 0 && position >= endMax) {
      TweenLite.set(mapContainer, { x: position });
    }
  }
}

InteractiveMap.scream = function() {
  map.getLastActive().attr("class", "");
  if (this.fullScreen) map.zoomed();
};

InteractiveMap.getMap = function() {
  return map;
};

InteractiveMap.toggle = function() {
  map.setTimeline();
};

export default InteractiveMap;
